<!-- <app-breadcrumb [title]="'Login'" [breadcrumb]="'Login'"></app-breadcrumb> -->
<!-- section start -->
<div class="login-page container-fluid">
    <div class="row">
        <div class="col-lg-4 login-left-bg theme-card">
            <div class="login-left">
                <img src="assets/images/icon/logo-a.png" alt="Toolexmart" width="50px" class="img-fluid">
                <p style="font-weight: 900;padding-bottom: 10px;">Get access to your Orders and shopping-cart</p>

            </div>
        </div>

        <div class="col-lg-8 login-right-bg theme-card" style="background: aliceblue;">
            <div>
                <div class="form-group" style="min-height:350px;">
                    <span>Sign in to Toolexmart</span>
                    <br>
                    <br>


                    <div class="popup-label"> &nbsp;New to Toolexmart? <a href="javaScript:void(0);"
                            (click)="Register()" class="text-primary"> Create new
                            account</a>
                    </div>
                    <br>
                    <hr>
                    <div class="popup-label"> Already have an account? <a href="javaScript:void(0);" (click)="Login()"
                            class=" text-primary">Login</a>
                    </div>
                    <br>
                    <hr>
                    <!-- <div class="popup-label"> Become Seller at AlibabaChair <a href="javaScript:void(0);"
                            class="text-primary">Register</a>
                    </div> -->

                    <!-- <label class="rodio-inline popup-label">
                        <input type="radio" value="0" (change)="onChangePersonal('false',template)" style="width: 20px;" />&nbsp;Personal
                        buyer
                        &nbsp;&nbsp;
                    </label>
                   
                    
                    
                    <label class="rodio-inline popup-label">
                        <input type="radio" value="1" [(ngModel)]="isSelected"
                            (change)="onChangePersonal('true',template)" style="width: 20px;"/>&nbsp;Business bulk
                        buyer
                    </label>
                    
                    
                    <br>
                    <br>
                    <div class="popup-label">
                        Already have an account? <a href="javaScript:void(0);" (click)="Login()"
                            class="text-primary">Login</a>
                    </div> -->
                </div>
            </div>

        </div>
    </div>

</div>
<ng-template #template>
    <div class="modal-header">
        <h4 class="modal-title pull-left"> Business bulk buyer</h4>

    </div>
    <div class="modal-body">
        <span style="font-size: 18px;
       font-family: ui-monospace;">If you are a business bulk buyer then you will be unable to buy less than 10
            piece for single design. Company
            name and
            GST number will be mandatory.
            <br />
            <br />
            Do you want to continue as business bulk buyer?
        </span>
    </div>
    <div class="modal-footer">

        <button type="button" (click)="fnSubmit('true')" class="btn btn-raised btn-primary">continue</button>
        <a class="close" (click)="close()"><img src="assets/images/icon/close.svg" alt="Close"></a>
        <button type="button" class="btn btn-raised btn-primary" (click)="modalRef.hide()">Cancel</button>
    </div>

</ng-template>
<!--Section ends-->